import { useRooms } from '../../matrix/hooks/useRooms';
import type { RoomNames } from '../../utils/matrixClient';

export const useGetMatrixRoomByName = () => {
  const rooms = useRooms();

  const getRoom = (uuid: string, type: RoomNames) => {
    return rooms?.find((room) => room.name.includes(type + '_' + uuid));
  };

  return { getRoom };
};
